import React, { createContext, useState, useEffect } from 'react';

export const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const [contactMessage, setContactMessage] = useState(null);
  const [balanceUpdate, setBalanceUpdate] = useState(null);
  const [referralCommission, setReferralCommission] = useState(null);
  const [ws, setWs] = useState(null); // Store the WebSocket instance

  useEffect(() => {
    const socket = new WebSocket('wss://whale-app-fk7fs.ondigitalocean.app'); 
    setWs(socket); 

    socket.onopen = () => {};

    socket.onmessage = (event) => {
      const message = JSON.parse(event.data);
  
      // Handle different message types
      switch (message.type) {
        case 'contact_message':
          setContactMessage(message.formData);
          break;
        case 'balance_Update':
        case 'balance_update':
          setBalanceUpdate(message);
          break;
        case 'referral_commission':
          setReferralCommission(message);
          break;
        case 'contact_message_response':
          break;
        default:
          break;
      }
    };

    socket.onclose = () => {};

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    return () => {
      socket.close();  
    };
  }, []);

  // Define a sendMessage function to be used by consuming components
  const sendMessage = (message) => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(message);
    } else {
      console.error("WebSocket is not open. Cannot send message.");
    }
  };

  return (
    <WebSocketContext.Provider value={{ ws, contactMessage, balanceUpdate, referralCommission, sendMessage }}>
      {children}
    </WebSocketContext.Provider>
  );
};
